import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    rootPersonalBonus: {
        padding: 10, 
        background: '#1b2039', 
        margin: '12px 0', 
        display: 'flex', 
        alignItems: 'center', 
        borderRadius: 8,
    },
    title: {
        color: '#fff'
    },
    mb12: {
        marginBottom: 12
    },
    root: {
        display: 'flex', 
        alignItems: 'center', 
        width: '100%'
    },
    wrap: {
        display: 'flex',
        width: '10%',
    },
    tab: {
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '25px',
        padding: '10px 0',
        marginRight: '20px',
        cursor: 'pointer',
        textAlign: 'center',
        userSelect: 'none',
    },
    search: {
        background: 'transparent',
        outline: 'none',
        marginLeft: 5,
        border: 0,
        color: '#eceff9',
        width: '75%'
    }
}));

export {
    useStyles,
}